import { TimestampsStringDict } from "../store/timestampsReducer";

export const SET_VERTICES = "SET_VERTICES";
export const SET_VERTICES_MODE = "SET_VERTICES_MODE";
export const SET_VERTEX_SELECTION = "SET_VERTEX_SELECTION";

export const SetVertices = (vertices: TimestampsStringDict) => {
    return { type: SET_VERTICES, vertices };
};
export const SetVerticesMode = (mode: string) => {
    return { type: SET_VERTICES_MODE, mode };
};
export const SetVertexSelection = (selection: number) => {
    return { type: SET_VERTEX_SELECTION, selection };
};
